import { Col, FormGroup, CustomInput } from "reactstrap"

const SwitchExtraButton = ({value, setValue, id, label, disabled = false}) => {
    return (
        <CustomInput type='checkbox' className={'custom-switch pt-2'} id={id}
                     name={id} checked={value}
                     onClick={() => setValue(!value)}
                     label={label} disabled={disabled}
        />
    )
}

export default SwitchExtraButton